import { render } from "./CustomersChat.vue?vue&type=template&id=cbc2c4ce&scoped=true"
import script from "./CustomersChat.vue?vue&type=script&lang=js"
export * from "./CustomersChat.vue?vue&type=script&lang=js"

import "./CustomersChat.vue?vue&type=style&index=0&id=cbc2c4ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbc2c4ce"]])

export default __exports__